import { useEffect, useState } from "react";

import { Radio, Typography } from "@mui/material";

import { ESameDayNoticePeriod } from "../../../../../@types";
import { useTeachingPolicy } from "../../../../../hooks/useTeachingPolicy";

const sameDayNoticePeriodOptions = [
	{
		text: "3 hours",
		value: ESameDayNoticePeriod.THREE_HOURS,
	},
	{
		text: "4 hours",
		value: ESameDayNoticePeriod.FOUR_HOURS,
	},
	{
		text: "5 hours",
		value: ESameDayNoticePeriod.FIVE_HOURS,
	},
	{
		text: "6 hours",
		value: ESameDayNoticePeriod.SIX_HOURS,
	},
	{
		text: "7 hours",
		value: ESameDayNoticePeriod.SEVEN_HOURS,
	},
	{
		text: "10 hours",
		value: ESameDayNoticePeriod.TEN_HOURS,
	},
	{
		text: "12 hours",
		value: ESameDayNoticePeriod.TWELVES_HOURS,
	},
];

export function SameDayNotice() {
	const { policy, savePolicy } = useTeachingPolicy();

	const [sameDayNoticePeriod, setSameDayNoticePeriod] =
		useState<ESameDayNoticePeriod | null>(null);

	useEffect(() => {
		if (policy) {
			setSameDayNoticePeriod(policy.sameDayNoticePeriod);
		}
	}, [policy]);

	return (
		<div className="section-separator">
			<Typography className="small-title-text bold">Same day notice</Typography>
			<Typography className="normal-text item-separator-tiny">
				Students can only book when the requested time allows you to prepare.
				How much notice do you need to prepare for a lesson?
			</Typography>
			<div className="item-separator-small" />
			{sameDayNoticePeriodOptions.map((option) => {
				return (
					<div
						className="radio-item-container"
						key={option.text}
						onClick={() => {
							if (option.value !== sameDayNoticePeriod) {
								setSameDayNoticePeriod(option.value);
								savePolicy({ sameDayNoticePeriod: option.value });
							}
						}}>
						<Radio
							checked={sameDayNoticePeriod === option.value}
							size="small"
						/>
						<Typography className="normal-text">{option.text}</Typography>
					</div>
				);
			})}
		</div>
	);
}
